const MEDICUS_CONTENT_HUB_TENANT_IDS = {
  DEVELOPMENT: 'c00001',
  UAT: 'e10001',
  STAGING: 'e30001',
  PRODUCTION: 'ea6614',
} as const;

const environment = import.meta.env.VITE_ENV?.toUpperCase();

/**
 * Used for NHS App SSO ONLY
 *
 * Resolves the Medicus Content Hub tenant ID based on the current environment.
 *
 * This tenant is used for the initial NHS App SSO backend request because at that stage
 * we do not yet know which tenant the user belongs to.
 *
 */
export function resolveMedicusContentHubTenantId(): string {
  return (
    MEDICUS_CONTENT_HUB_TENANT_IDS[
      environment as keyof typeof MEDICUS_CONTENT_HUB_TENANT_IDS
      ] ?? MEDICUS_CONTENT_HUB_TENANT_IDS.PRODUCTION
  );
}
